import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './pedidoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import cookie from 'react-cookies'
import { setModoTela, setFiltro, initForm, salvar, excluir, getLista, getListaFreteTipo } from './pedidoActions';
import { getLista as getListaStatus } from '../compraStatus/compraStatusActions';
import { getLista as getListaCliente } from '../cliente/clienteActions';
import { getLista as getListaFornecedor } from '../fornecedor/fornecedorActions';
import { getLista as getListaTransportadora } from '../transportadora/transportadoraActions';
import { getLista as getListaFormaPagamento } from '../formaPagamento/formaPagamentoActions';

import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDate from '../common/form/labelAndInputDate';

import ReactExport from 'react-export-excel-fixed-xlsx';

class Pedido extends Component {

	state = {
		linhaSelecionada: null,
		paginacaoIndice: 0
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaStatus();
		this.props.getListaCliente();
		this.props.getListaFornecedor();
		this.props.getListaTransportadora();
		this.props.getListaFormaPagamento();
		this.props.getListaFreteTipo();

		this.props.setFiltro({
			...this.props.filtro,
			pesquisaGlobal: ''
		});
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {		

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		const listaSituacoes = [{ id: 'aberto', valor: 'Aberto' }, { id: 'backorder', valor: 'Backorder' }, { id: 'finalizado', valor: 'Finalizado' }];

		let lista = (this.props.lista).filter(item => {
			
			if (this.state.pesquisar
				&& !(`
					${item.numero} 
					${DateFormat.formatarDataSqlParaTela(item.datahora_pedido)} 
					${item.nome_usuario}
					${item.itens.map(pedidoItem => `
						${pedidoItem.nome_forma_pagamento || ''}
						${DateFormat.formatarDataSqlParaTela(pedidoItem.data_previsao_entrega) || ''}
						${pedidoItem.nome_status || ''}
						${pedidoItem.nome_fornecedor || ''}
						${pedidoItem.nome_transportadora || ''}
						${pedidoItem.nome_usuario || ''}
						${pedidoItem.nome_tipo || ''}
						${pedidoItem.nome_categoria || ''}
						${pedidoItem.nome_cliente || ''}
						${pedidoItem.nome_produto || ''}
						${pedidoItem.nome_prioridade || ''}
						${pedidoItem.cor_prioridade || ''}
						${pedidoItem.nome_usuario_solicitacao || ''}
						${pedidoItem.numero_solicitacao || ''}
						${pedidoItem.nota_fiscal || ''}
						${pedidoItem.nome_frete_tipo || ''}
					`).join(' ')}
					${item.historicos.map(pedidoHistorico => pedidoHistorico.descricao).join(' ')}
				`).toUpperCase().includes((this.props.filtro.pesquisa || '').toUpperCase())) {
				return false;
			}
			return true;
		});
		
		let listaExportar = [];
		lista.forEach(item => {
			item.itens.map(pedidoItem => {

				let prazo = parseInt(pedidoItem.prazo_solicitacao || 0) - parseInt(pedidoItem.dias_abertura_solicitacao || 0);

				listaExportar.push({
					numero: item.numero,
					datahora_pedido: DateFormat.formatarDataHoraSqlParaTela(item.datahora_pedido),
					nome_produto: pedidoItem.nome_produto,
					quantidade: parseFloat(pedidoItem.quantidade),
					valor: parseFloat(pedidoItem.valor),
					data_previsao_entrega: DateFormat.formatarDataSqlParaTela(pedidoItem.data_previsao_entrega) || 'Sem Previsão',
					prazo_atendimento: !pedidoItem.finalizado ? (
						prazo > 0 ? `Falta${prazo == 1 ? '' : 'm'} ${prazo} dia${prazo == 1 ? '' : 's'}`
						: (prazo == 0 ? 'Venceu hoje' : `Vencido há ${prazo * -1} dia${prazo == -1 ? '' : 's'}`)
					) : (
						'Atendido'
					),
					nome_status: pedidoItem.nome_status,
					nome_usuario: item.nome_usuario
				});
			});
		});

		return (
			<ContentCard>

				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										listaSolicitacoesSelecionadas: []
									});
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>

					<Row>
						<LabelAndInputDate
							label='Data Inicial'
							placeholder='Informe'
							cols='6 3 2 2'
							value={this.props.filtro.dataInicial}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									dataInicial: value
								});
							}} />

						<LabelAndInputDate
							label='Data Final'
							placeholder='Informe'
							cols='6 3 2 2'
							value={this.props.filtro.dataFinal}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									dataFinal: value
								});
							}} />

						<Select
							label='Fornecedor'
							placeholder='Informe'
							options={this.props.listaFornecedor}
							cols='12 6 3 3'
							value={this.props.filtro.idFornecedor}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									idFornecedor: value
								});
							}} />
						
						<Select
							label='Cliente'
							placeholder='Informe'
							options={this.props.listaCliente}
							cols='12 6 3 3'
							value={this.props.filtro.idCliente}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									idCliente: value
								})
							}} />
						
						<Select
							label='Situação'
							placeholder='Informe'
							options={listaSituacoes}
							cols='12 6 2 2'
							multiple
							value={(this.props.filtro.situacoes || [])}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									situacoes: (value || []).map(item => item.value)
								});

								cookie.save('cookieSituacoes', (value || []).map(item => item.value), { path: '/' });

							}} />

						<Grid cols='12 6 6 8'>
							<input className='form-control'
								placeholder='Pesquisar'
								type='text'
								value={this.state.pesquisar}
								onChange={e => {
									this.setState({ ...this.state, pesquisar: e.target.value, paginacaoIndice: 0 });
								}} />
						</Grid>

						<Grid cols='6 3 3 2'>
							<Button
								text='Atualizar'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setFiltro({
										...this.props.filtro,
										pesquisa: this.state.pesquisar
									});
									this.props.getLista();
								}} />
						</Grid>
						<Grid cols='6 3 3 2'>
							<ExcelFile
								filename={'Pedidos'}
								element={
									<Button
										text='Exportar'
										type={'primary'}
										icon={'fa fa-plus'} />
								}>
								<ExcelSheet data={listaExportar} name='Pedidos'>
									<ExcelColumn label='Número' value='numero' />
									<ExcelColumn label='Data/Hora' value='datahora_pedido' />
									<ExcelColumn label='Produto' value='nome_produto' />
									<ExcelColumn label='Qtd.' value='quantidade' type='number' />
									<ExcelColumn label='Vlr.' value='valor' type='number' />
									<ExcelColumn label='Previsão' value='data_previsao_entrega' />
									<ExcelColumn label='Prazo Atend.' value='prazo_atendimento' />
									<ExcelColumn label='Status' value='nome_status' />
									<ExcelColumn label='Aberto Por' value='nome_usuario' />
								</ExcelSheet>
							</ExcelFile>
						</Grid>
					</Row>						

					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Número</Th>
								<Th alignCenter>Data/Hora</Th>
								<Th alignCenter>
									<div style={{ display: 'flex' }}>
										<div style={{ width: '40%' }}>
											Produto
										</div>
										<div style={{ width: '12%' }}>
											Qtd.
										</div>
										<div style={{ width: '12%' }}>
											Vlr.
										</div>
										<div style={{ width: '12%' }}>
											Previsão
										</div>
										<div style={{ width: '12%' }}>
											Prazo Atend.
										</div>
										<div style={{ width: '12%' }}>
											Status
										</div>
									</div>
								</Th>
								<Th alignCenter>Aberto Por</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => {

								let borderTop= '2px solid rgb(0, 48, 138, 0.8)';

								return (
									<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
										onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td alignCenter bold borderTop={borderTop}>{item.numero}</Td>
										<Td alignCenter borderTop={borderTop}>{DateFormat.formatarDataSqlParaTela(item.datahora_pedido)}</Td>
										<Td alignCenter small paddingTop={'0'} paddingBottom={'0'} borderTop={borderTop} title='Itens' >
											{item.itens.map((pedidoItem, j) => {

												let prazo = parseInt(pedidoItem.prazo_solicitacao || 0) - parseInt(pedidoItem.dias_abertura_solicitacao || 0);

												return (
													<div key={pedidoItem.id} 
														style={{
															display: 'flex',
															alignItems: 'center',
															borderLeft: '1px solid #dee2e6',
															borderRight: '1px solid #dee2e6',
															borderTop: j > 0 ? '1px solid #dee2e6' : null,
															padding: 2
														}}>
														<div style={{ width: '40%' }}>
															{pedidoItem.nome_produto}
														</div>
														<div style={{ width: '12%' }}>
															{FormatUtils.formatarValorTela(pedidoItem.quantidade, 2)}
														</div>
														<div style={{ width: '12%' }}>
															R$ {FormatUtils.formatarValorTela(pedidoItem.valor, 2)}
														</div>
														<div style={{ width: '12%' }}>
															{DateFormat.formatarDataSqlParaTela(pedidoItem.data_previsao_entrega) || 'Sem Previsão'}
														</div>
														<div style={{ width: '12%', color: prazo <= 0 ? '#b50000' : '#000000' }}>
															{!pedidoItem.finalizado ? (
																prazo > 0 ? `Falta${prazo == 1 ? '' : 'm'} ${prazo} dia${prazo == 1 ? '' : 's'}`
																: (prazo == 0 ? 'Venceu hoje' : `Vencido há ${prazo * -1} dia${prazo == -1 ? '' : 's'}`)
															) : (
																'Atendido'
															)}
														</div>
														<div style={{ width: '12%' }}>
															{pedidoItem.nome_status}
														</div>
													</div>
												);
											})}
										</Td>
										<Td alignCenter borderTop={borderTop}>{item.nome_usuario}</Td>
										<Td alignRight minWidth={10} borderTop={borderTop}>																			
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {
													this.props.setModoTela('cadastro', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />

											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {
													this.props.setModoTela('exclusao', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />
										</Td>
									</Tr>
								);
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.pedido.modoTela,
	aguardando: state.pedido.aguardando,
	lista: state.pedido.lista,
	filtro: state.pedido.filtro,
	listaCliente: state.cliente.listaSelect,
	listaFornecedor: state.fornecedor.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, getListaFreteTipo,
	getListaStatus, getListaCliente, getListaFornecedor, getListaTransportadora, getListaFormaPagamento
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Pedido);